import $ from 'jquery'

$(document).on('turbolinks:load', function() {
  const requiredDocsMap = {
    associate: [
      "partnership_deed",
      "certificate_by_registrar",
      "certifcate_of_incorporation",
      "frc"
    ],
    corporate: [
      "memorandum_of_association",
      "article_of_association",
      "gst_certificate"
    ]
  };

  function setRequiredDocs(selectedClass) {
    // Remove "required" from all docs first
    $.each(Object.values(requiredDocsMap).flat(), function(_, id) {
      const $el = $('#' + id);
      if ($el.length) $el.prop('required', false);
    });

    // Add "required" to relevant docs if not already attached
    if (requiredDocsMap[selectedClass]) {
      $.each(requiredDocsMap[selectedClass], function(_, id) {
        const $el = $('#' + id);
        if ($el.length && $el.data('attached') !== true) {
          $el.prop('required', true);
        }
      });
    }
  }

  function toggleSections() {
    const selected = $('#membership_class').val();

    if (selected === "associate") {
      $('#associate-documents').show();
      $('#corporate-documents').hide();
    } else if (selected === "corporate") {
      $('#associate-documents').hide();
      $('#corporate-documents').show();
    } else {
      $('#associate-documents').hide();
      $('#corporate-documents').hide();
    }

    setRequiredDocs(selected);
  }

  // Initial state
  toggleSections();

  // On change
  $(document).on('change', '#membership_class', toggleSections);
});
